import { Vue, Component, Prop } from 'vue-property-decorator';
import Palette from '@/interfaces/Palette';
import { sortForDisplay } from '@/utils/palette-utils';

@Component({})
export default class PaletteHistory extends Vue {
  @Prop() private currentPalette!: Palette;
  private palettes: Palette[] = [];
  private clickedIndex = -1;

  /**
   * save method is called just before new component is selected
   */
  public save() {
    if (this.clickedIndex >= 0) {
      this.palettes.splice(this.clickedIndex + 1);
      this.clickedIndex = -1;
    } else {
      // push new palettes
      this.pushPalette(this.palettes, sortForDisplay([...this.currentPalette]));
    }
  }

  protected mounted() {
    //
  }

  protected getLimitedPalettesForDisplay(count = 10) {
    const limitedPalettes = [...this.palettes];
    if (this.currentPalette && this.clickedIndex < 0) {
      this.pushPalette(
        limitedPalettes,
        sortForDisplay([...this.currentPalette])
      );
    }
    const startIndex =
      limitedPalettes.length <= count ? 0 : limitedPalettes.length - count;
    const endIndex = limitedPalettes.length;

    return limitedPalettes.slice(startIndex, endIndex);
  }

  protected onClickPalette(index: number, count = 10) {
    if (this.clickedIndex === index) {
      this.palettes.splice(this.clickedIndex);
      this.clickedIndex = -1;
    } else {
      if (this.clickedIndex < 0) {
        this.pushPalette(this.palettes, sortForDisplay([...this.currentPalette]));
      }
      this.clickedIndex = index;

      const paletteIndex = Math.max(0, this.palettes.length - count) + index;
      this.emitPaletteClicked(this.palettes[paletteIndex]);
    }
  }

  protected isDimmed(index: number) {
    return -1 < this.clickedIndex && this.clickedIndex < index;
  }

  private pushPalette(palettes: Palette[], ...items: Palette[]) {
    palettes.push(...items);
  }

  private emitPaletteClicked(palette: Palette) {
    if (!palette || palette.length === 0) {
      throw new Error('Invalid palette was given.');
    }
    this.$emit('paletteClicked', palette);
  }
}
